import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ListYourEquipmentBtn = ({
  isLoggedIn,
  zeroMargin = false,
  fullWidth = false,
  sx = {},
  handleClick = null,
}: any) => {
  const navigate = useNavigate();
  return (
    <Button
      fullWidth={fullWidth}
      onClick={() => {
        navigate("/list-equipment");
        handleClick && handleClick();
      }}
      sx={{
        backgroundColor: "primary.main",
        color: "white",
        display: "block",
        fontSize: "15px",
        fontWeight: 500,

        "&:hover": {
          backgroundColor: "primary.main",
          color: "white",
        },
        ...(zeroMargin ? { m: 0 } : { my: 2, ml: 2 }),
        ...sx,
      }}
    >
      List Your Equipment
    </Button>
  );
};

export default ListYourEquipmentBtn;
